import StyledIcon from '@/atoms/Icon/styles';
import colors from '@/theme/constants/colors';
import pxToRem from '@/theme/helpers/pxToRem';
import typography from '@/theme/typography';
import styled from 'styled-components';
import {StyledButtonProps} from './typings';

export const StyledButton = styled.button<StyledButtonProps>`
  // This &&& priority is needed to avoid the button being overridden by Bootstrap.css legacy styles
  // and that can be removed once we remove Bootstrap.css from the project
  &&& {
    cursor: pointer;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: ${colors.darkBlue100};
    padding: ${pxToRem(5)} ${pxToRem(10)};
    ${typography.Body2}

    ${StyledIcon} {
      margin-right: ${pxToRem(5)};
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: ${colors.grey25};
      }
    }

    &:focus {
      outline: none;
    }
  }
`;
